import React from 'react'
import { useEffect, useRef, useState } from "react";
import "./Users.css";
import { Modal, Select, Checkbox, Radio, Collapse } from "antd";
import DatePicker, { DateObject } from "react-multi-date-picker";
import "react-multi-date-picker/styles/colors/green.css";
import { ErrorMessage, Field, Form, Formik } from "formik";
import {
    validCardNumber,
    validEmail,
    validFixedPhone,
    validNationalCode,
    validNightNumber,
} from "../../Regex";
import { validPhoneNumber } from "../../Regex";
import { validCode } from "../../Regex";
import { useUserActions } from "./connectApi/users";
import { ToastContainer } from "react-toastify";
import { notification } from "antd";
import { useNavigate, useParams } from "react-router-dom";
//gregorian calendar & locale
import gregorian from "react-date-object/calendars/gregorian";
import gregorian_fa from "react-date-object/locales/gregorian_fa";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import ConvertNumbers from "@smakss/convert-numbers";
import { useSubscriptions } from "../Subscriptions/fetchApi";
import { useLocations } from "../CityProvinceManagement/connectApi/location";
import { CheckCircleOutlined } from "@ant-design/icons";
import { useAuth } from '../Login/connectApi/auth';

function UserEdit(props) {
    const { getUserInit } = useSubscriptions((state) => state.actions);
    const { getUserById, editUserNew } = useUserActions((state) => state.actions)
    const userSideBarAccess = useAuth((state) => state.userSideBarAccess)
    const { getUserLogin } = useAuth((state) => state.actions)
    const user = useUserActions((state) => state.user);
    // const provinses = useLocations((state) => state.provinses)
    const provinceByParentId = useLocations((state) => state.provinceByParentId)
    const cityByParentId = useLocations((state) => state.cityByParentId)
    const countryes = useLocations((state) => state.countryes)
    const { getAllCountryes, getLocationByParentId, getOneProvince, getOneCity } = useLocations((state) => state.actions)
    const userInit = useSubscriptions((state) => state.userInit);
    const userInfo = useUserActions((state) => state.userInfo)
    const navigate = useNavigate();
    const [cardNumberInputValue, setCardNumberInputValue] = useState("");
    // const [state, setState] = useState({
    //     date: user?.registerDate ? new DateObject({
    //         date: user.registerDate,
    //         calendar: persian,
    //         locale: persian_fa
    //     }) : null,
    //     format: "YYYY-MM-DD",
    //     gregorian: ""
    // });
    const [state, setState] = useState({
        date: user?.registerDate
            ? new DateObject({
                  date: user.registerDate,
                  calendar: persian,
                  locale: persian_fa,
              })
            : null,
        format: "YYYY-MM-DD",
        gregorian: user?.registerDate || "", // Initialize with the original Gregorian date
    });


    const [shebaNumber, setShebaNumber] = useState("");
    const [gender, setGender] = useState(2);
    const [isShowDates, setIsShowDates] = useState(false);
    const [seconds, setSeconds] = useState(1);
    const [minutes, setMinutes] = useState(2);
    const [activeInterval, setActiveInterval] = useState(false);
    const [intervalId, setIntervalId] = useState(null);
    const [cardNumbersUserSet, setCardNumbersUserSet] = useState([]);
    const [isCityManager, setIsCityManager] = useState(user?.userTypeCode == 5);
    const [cardNumbersUserSetWitoutID, setCardNumbersUserSetWitoutID] = useState([]);
    const [activeKeys, setActiveKeys] = useState([""]);
    const [selectedCountry, setSelectedCountry] = useState(user.country)
    const [selectedProvince, setSelectedProvince] = useState(user.state)
    const [selectedProvince2, setSelectedProvince2] = useState(0)
    const [selectedProvince3, setSelectedProvince3] = useState(0)
    const [selectedCity, setSelectedCity] = useState(user.city)
    const [selectedCity2, setSelectedCity2] = useState(0)
    const [selectedCity3, setSelectedCity3] = useState(0)
    const [countryName, setCountryName] = useState(user?.countryName)
    const [provinceName, setProvinceName] = useState(user?.stateName)
    const [cityName, setCityName] = useState(user?.cityName)
    const datePickerRef = useRef(null);
    const [isDateChanged, setIsDateChanged] = useState(false);
    const {
        createTeannateUser,
        editAddUser,
        addCardNumbers,
        saveUserPersonnelImage,
        saveUsernationalImage,
        saveUserBirthCertificationImage,
        addLogin
    } = useUserActions((state) => state.actions);
    const [selectedAccess, setSelectedAccess] = useState({
        cityAndProvinceManagement: userSideBarAccess.canAccessCityState,
        transactions: userSideBarAccess.canAccessTransactions,
        createNewUser: userSideBarAccess.canAccessCreateUser,
        usersList: userSideBarAccess.canAccessUsersList,
        // settings: userSideBarAccess.z,
        createFile: userSideBarAccess.canAccessCreateAds,
        filesList: userSideBarAccess.canAccessAdsList,
        inCompleteFiles: userSideBarAccess.canAccessIncompleteAdsList,
        awaitingApprovalFiles: userSideBarAccess.canAccessWaitingAds,
        callCenter: userSideBarAccess.canAccessMesageCenter,
        monitoring: userSideBarAccess.canAccessMonitoring,
        messages: userSideBarAccess.canAccessMessages,
        support: userSideBarAccess.canAccessSupport,
        // requests: userSideBarAccess.z,
        // messagesList: userSideBarAccess.canAccessMessages,
        reporteds: userSideBarAccess.canAccessReports,
        automaticMessage: userSideBarAccess.canAccessAlerts,
        groupMessage: userSideBarAccess.canAccessBulkMessages,
        systemErrorReport: userSideBarAccess.canAccessReports,
        // calls: userSideBarAccess.z,
        TariffManagement: userSideBarAccess.canAccessTariffManagement,
        DiscountsAndPrivileges: userSideBarAccess.canAccessDiscountsAndScores,
        price: userSideBarAccess.canAccessPrices,
        prize: userSideBarAccess.canAccessPrize,
        ContentManagement: userSideBarAccess.canAccessContentManagement,
        RealEstateConsultants: userSideBarAccess.canAccessRealEstateAgents,
        RealEstateAgency: userSideBarAccess.canAccessRealEstateAgencies,
        contractors: userSideBarAccess.canAccessConstructors,
        users: userSideBarAccess.canAccessUsers,
        slides: userSideBarAccess.canAccessSlides,
        rules: userSideBarAccess.canAcceessRules,
        // messagesCadr: userSideBarAccess.z,
        about: userSideBarAccess.canAccessAbout,
        // automaticMsg: false,
        canAccessBulkMessages: userSideBarAccess.canAccessBulkMessages,
        messagesOption: userSideBarAccess.canAccessMessagesOptions,
        canAccessBlog: userSideBarAccess.canAccessBlog,
        canAccessAds: userSideBarAccess.canAccessAds,
        canAccessAdsValidity: userSideBarAccess.canAccessAdsValidity,

    });

    // const toggleSelection = (key) => {
    //   setSelectedAccess((prev) => ({
    //     ...prev,
    //     [key]: !prev[key],
    //   }));
    // };


    useEffect(() => {
        setSelectedAccess({
            cityAndProvinceManagement: userSideBarAccess.canAccessCityState,
            transactions: userSideBarAccess.canAccessTransactions,
            createNewUser: userSideBarAccess.canAccessCreateUser,
            usersList: userSideBarAccess.canAccessUsersList,
            // settings: userSideBarAccess.z,
            createFile: userSideBarAccess.canAccessCreateAds,
            filesList: userSideBarAccess.canAccessAdsList,
            inCompleteFiles: userSideBarAccess.canAccessIncompleteAdsList,
            awaitingApprovalFiles: userSideBarAccess.canAccessWaitingAds,
            callCenter: userSideBarAccess.canAccessMesageCenter,
            monitoring: userSideBarAccess.canAccessMonitoring,
            messages: userSideBarAccess.canAccessMessages,
            support: userSideBarAccess.canAccessSupport,
            // requests: userSideBarAccess.z,
            // messagesList: userSideBarAccess.canAccessMessages,
            reporteds: userSideBarAccess.canAccessReports,
            automaticMessage: userSideBarAccess.canAccessAlerts,
            groupMessage: userSideBarAccess.canAccessBulkMessages,
            systemErrorReport: userSideBarAccess.canAccessReports,
            // calls: userSideBarAccess.z,
            TariffManagement: userSideBarAccess.canAccessTariffManagement,
            DiscountsAndPrivileges: userSideBarAccess.canAccessDiscountsAndScores,
            price: userSideBarAccess.canAccessPrices,
            prize: userSideBarAccess.canAccessPrize,
            ContentManagement: userSideBarAccess.canAccessContentManagement,
            RealEstateConsultants: userSideBarAccess.canAccessRealEstateAgents,
            RealEstateAgency: userSideBarAccess.canAccessRealEstateAgencies,
            contractors: userSideBarAccess.canAccessConstructors,
            users: userSideBarAccess.canAccessUsers,
            slides: userSideBarAccess.canAccessSlides,
            rules: userSideBarAccess.canAcceessRules,
            // messagesCadr: userSideBarAccess.z,
            about: userSideBarAccess.canAccessAbout,
            // automaticMsg: false,
            canAccessBulkMessages: userSideBarAccess.canAccessBulkMessages,
            messagesOption: userSideBarAccess.canAccessMessagesOptions,
            canAccessBlog: userSideBarAccess.canAccessBlog,
            canAccessAds: userSideBarAccess.canAccessAds,
            canAccessAdsValidity: userSideBarAccess.canAccessAdsValidity,
        });
    }, [userSideBarAccess]);
    useEffect(() => {

        if (user?.userTypeCode == 5) {


            setIsCityManager(true)
        } else {


        }
        setCountryName(user?.countryName)
        setSelectedCountry(user?.country)
        setProvinceName(user?.stateName)
        setSelectedProvince(user?.state)
        setSelectedCity(user?.city)
        setCityName(user?.cityName)
    }, [user])


    const params = useParams();
    const toggleSelection = (key) => {
        setSelectedAccess((prev) => {
            const newState = { ...prev, [key]: !prev[key] };

            if (key === "TariffManagement") {
                newState.DiscountsAndPrivileges = newState[key]; // Sync with TariffManagement
                newState.price = newState[key]; // Sync with TariffManagement
                newState.prize = newState[key]; // Sync with TariffManagement

            }
            if (key === "ContentManagement") {
                newState.slides = newState[key];
                newState.rules = newState[key];
                // newState.messagesCadr = newState[key];
                newState.about = newState[key];

            }
            if (key === "canAccessAds") {
                newState.createFile = newState[key];
                newState.filesList = newState[key];
                newState.canAccessAdsValidity = newState[key];

            }
            if (key === "users") {
                newState.createNewUser = newState[key];
                newState.usersList = newState[key];
                // newState.settings = newState[key];
            }

            if (key === "callCenter" && !newState[key]) {
                newState.support = false;
                // newState.messagesList = false;
                newState.reporteds = false;
                newState.automaticMessage = false;
                newState.canAccessBulkMessages = false;
                newState.messagesOption = false;
            }
            if (key === "canAccessAds" && !newState[key]) {
                newState.createFile = false;
                newState.filesList = false;
                newState.canAccessAdsValidity = false;

            }
            if (key === "TariffManagement" && !newState[key]) {
                newState.DiscountsAndPrivileges = false;
                newState.price = false;
                newState.prize = false;

            }
            if (key === "users" && !newState[key]) {
                newState.createNewUser = false;
                newState.usersList = false;
                // newState.settings = false;
            }
            return newState;
        });
    };
    const genderList = [
        { id: 1, title: "خانم" },
        { id: 2, title: "آقا" },
    ];



    useEffect(() => {
        getAllCountryes("1");

    }, []);
    const addCardNumberHandler = async () => {
        if (cardNumberInputValue.length === 19) {
            cardNumbersUserSet.push({
                id: crypto.randomUUID(),
                cardNumber: cardNumberInputValue,
                userCode: "",
            });
            cardNumbersUserSetWitoutID.push({
                cardNumber: cardNumberInputValue.replace(/\s+/g, ''),
                userCode: "",
            });
            setCardNumberInputValue("");
        } else openCardNotification();
    };

    useEffect(() => {
        localStorage.removeItem("userId");
        getUserInit(localStorage?.getItem("pelakUserId"))
        getOneProvince(1)
        getUserLogin(params.id)
        getUserById(params.id)
    }, []);

    const handleCountriesChange = (e) => {
        getOneProvince(e?.target.value)
        setSelectedCountry(e?.target.value)
        setActiveKeys([""])
    }
    const handleProvinceChange = (e) => {
        setSelectedProvince(e?.target.value)
        getOneCity(e?.target.value)
        setActiveKeys([""])
    }
    const handleProvinceChange2 = (e) => {
        setSelectedProvince2(e?.target.value)
        getOneCity(e?.target.value)
        setActiveKeys([""])
    }
    const handleProvinceChange3 = (e) => {
        setSelectedProvince3(e?.target.value)
        getOneCity(e?.target.value)
        setActiveKeys([""])
    }
    const handleCityChange = (e) => {
        setSelectedCity(e?.target.value)
        setActiveKeys([""])
    }
    const handleCityChange2 = (e) => {
        setSelectedCity2(e?.target.value)
        setActiveKeys([""])
    }
    const handleCityChange3 = (e) => {
        setSelectedCity3(e?.target.value)
        setActiveKeys([""])
    }
    const onCollapseChange = (keys) => {
        setActiveKeys(keys);
    };
    const CountriesCollapse = [
        {
            key: '1',
            label: ` کشور /${countryName}`,
            children: (
                <div className="flex flex-col space-y-4">
                    <Radio.Group

                        onChange={handleCountriesChange}
                        className="flex flex-col"
                    >
                        {countryes.map((city) => (
                            <Radio key={city.id} value={city.id}>
                                {city.locName}
                            </Radio>
                        ))}
                    </Radio.Group>
                </div>)
        }
    ]
    const provincesCollapse = [
        {
            key: '2',
            label: ` استان /${provinceName}`,
            children: (
                <div className="flex flex-col space-y-4">
                    <Radio.Group

                        onChange={handleProvinceChange}
                        className="flex flex-col"
                    >
                        {provinceByParentId.map((city) => (
                            <Radio key={city.id} value={city.id}>
                                {city.locName}
                            </Radio>
                        ))}
                    </Radio.Group>
                </div>)
        }
    ]
    const provincesCollapse2 = [
        {
            key: '5',
            label: 'استان',
            children: (
                <div className="flex flex-col space-y-4">
                    <Radio.Group

                        onChange={handleProvinceChange2}
                        className="flex flex-col"
                    >
                        {provinceByParentId.map((city) => (
                            <Radio key={city.id} value={city.id}>
                                {city.locName}
                            </Radio>
                        ))}
                    </Radio.Group>
                </div>)
        }
    ]
    const provincesCollapse3 = [
        {
            key: '7',
            label: 'استان',
            children: (
                <div className="flex flex-col space-y-4">
                    <Radio.Group

                        onChange={handleProvinceChange3}
                        className="flex flex-col"
                    >
                        {provinceByParentId.map((city) => (
                            <Radio key={city.id} value={city.id}>
                                {city.locName}
                            </Radio>
                        ))}
                    </Radio.Group>
                </div>)
        }
    ]
    const citiesCollapse = [
        {
            key: '3',
            label: ` شهر /${cityName}`,
            children: (
                <div className="flex flex-col space-y-4">
                    <Radio.Group

                        onChange={handleCityChange}
                        className="flex flex-col"
                    >
                        {cityByParentId.map((city) => (
                            <Radio key={city.id} value={city.id}>
                                {city.locName}
                            </Radio>
                        ))}
                    </Radio.Group>
                </div>)
        }
    ]
    const citiesCollapse2 = [
        {
            key: '8',
            label: 'شهر',
            children: (
                <div className="flex flex-col space-y-4">
                    <Radio.Group

                        onChange={handleCityChange2}
                        className="flex flex-col"
                    >
                        {cityByParentId.map((city) => (
                            <Radio key={city.id} value={city.id}>
                                {city.locName}
                            </Radio>
                        ))}
                    </Radio.Group>
                </div>)
        }
    ]
    const citiesCollapse3 = [
        {
            key: '6',
            label: 'شهر',
            children: (
                <div className="flex flex-col space-y-4">
                    <Radio.Group

                        onChange={handleCityChange3}
                        className="flex flex-col"
                    >
                        {cityByParentId.map((city) => (
                            <Radio key={city.id} value={city.id}>
                                {city.locName}
                            </Radio>
                        ))}
                    </Radio.Group>
                </div>)
        }
    ]
    var date = new DateObject();
    const monthRegister =
        date.month.number < 10 ? "0" + date.month.number : date.month.number;
    const dayRegister = date.day < 10 ? "0" + date.day : date.day;
    const minuteRegister = date.minute < 10 ? "0" + date.minute : date.minute;
    const secondRegister = date.second < 10 ? "0" + date.second : date.second;
    const hourRegister = date.hour < 10 ? "0" + date.hour : date.hour;
    const registerDateResult =
        date.year +
        "-" +
        monthRegister +
        "-" +
        dayRegister +
        "T" +
        hourRegister +
        ":" +
        minuteRegister +
        ":" +
        secondRegister +
        "." +
        date.millisecond +
        "Z";

    const changeCardNumberInputValueHandler = (e) => {
        let value = e.target.value.replace(/\D/g, ""); // حذف تمامی کاراکترهای غیر عددی
        value = value.replace(/(.{4})/g, "$1 ").trim(); // اضافه کردن فاصله بعد از هر 4 رقم
        setCardNumberInputValue(value);
    };

    const shebaNumberHandler = (e) => {
        let value = e.target.value.replace(/\D/g, "");
        setShebaNumber(value);
    };


    useEffect(() => {
        if (activeInterval && minutes === 0 && seconds === 0) {
            clearInterval(intervalId);
            setActiveInterval(false);
        }
    }, [minutes, seconds, activeInterval, intervalId]);

    const countDownHandler = () => {
        if (!activeInterval) {
            setActiveInterval(true);
            const newIntervalId = setInterval(() => {
                setSeconds((prevSeconds) => {
                    if (prevSeconds === 0) {
                        if (minutes === 0) {
                            clearInterval(newIntervalId);
                            return 0;
                        } else {
                            setMinutes((prevMinutes) => prevMinutes - 1);
                            return 59;
                        }
                    } else {
                        return prevSeconds - 1;
                    }
                });
            }, 1000);
            setIntervalId(newIntervalId);
        }
    };
    //remove the interval on onmount time
    useEffect(() => {
        return () => {
            if (intervalId) clearInterval(intervalId);
        };
    }, [intervalId]);

    const handleRemoveCancel = () => {
        setIsModalRemoveOpen(false);
    };

    const [isModalRemoveOpen, setIsModalRemoveOpen] = useState(false);

    const removeCardHandler = async () => {
        setCardNumbersUserSet(
            cardNumbersUserSet.filter((item) => item.id !== selected.id)
        );
        setIsModalRemoveOpen(false);
    };

    const [selected, setSelected] = useState();

    const showRemoveModal = (item) => {
        setIsModalRemoveOpen(true);
        setSelected(item);
    };

    const [newName, setNewName] = useState("");
    const [isModalEditOpen, setIsModalEditOpen] = useState(false);
    const [editbleCardNumber, setEditble] = useState();

    const showEditModal = (item) => {
        setIsModalEditOpen(true);
        setEditble(item);
        setNewName(item.cardNumber);
        // getCardNumbers(JSON.parse(localStorage.getItem("userId")))
        // setCardNumbersUserSet(cardNumbers)
    };

    const [personelPicName, setPersonelPicName] = useState();
    const [personelPicBinery, setPersonelPicBinery] = useState();
    const seveProfilePhotoHandler = (e) => {
        if (e.target.files && e.target.files[0]) {
            setPersonelPicName(URL.createObjectURL(e.target.files[0]));
            setPersonelPicBinery(e.target.files[0]);
        }
    };

    const [nationalCardPicName, setNationalCardPicName] = useState();
    const [nationalCardPicBinery, setNationalCardPicBinery] = useState();

    const seveNationalCardPhotoHandler = (e) => {
        if (e.target.files && e.target.files[0]) {
            setNationalCardPicName(URL.createObjectURL(e.target.files[0]));
            setNationalCardPicBinery(e.target.files[0]);
        }
    };

    const [certificationPicName, setCertificationPicName] = useState();
    const [certificationPicBinery, setCertificationPicBinery] = useState();
    const saveUserBirthCertificationImageHandler = (e) => {
        if (e.target.files && e.target.files[0]) {
            setCertificationPicName(URL.createObjectURL(e.target.files[0]));
            setCertificationPicBinery(e.target.files[0]);
        }
    };
    const [documents, setDocuments] = useState();
    const saveDocumentHandler = (e) => {
        if (e.target.files && e.target.files[0]) {
            setDocuments(URL.createObjectURL(e.target.files[0]));
        }
    };
    const convertNumbers2English = (string) => {
        return string.replace(/[\u0660-\u0669]/g, function (c) {
            return c.charCodeAt(0) - 0x0660;
        }).replace(/[\u06f0-\u06f9]/g, function (c) {
            return c.charCodeAt(0) - 0x06f0;
        });
    }


    const convert = (date, format = state.format) => {
        if (!date) return; // Ensure date is valid
    
        let object = { date, format };
    
        setState((prev) => ({
            ...prev,
            date: new DateObject(object), // Update the selected date
            gregorian: new DateObject(object)
                .convert(gregorian, gregorian_fa)
                .format("YYYY-MM-DD"),
        }));
    
        setIsDateChanged(true); // Mark the date as changed
    };
    const handleShowDate = () => {
        // setIsShowDates(!isShowDates);
        setIsShowDates(!isShowDates);
        if (datePickerRef.current) {
            datePickerRef.current.openCalendar(); // Open calendar programmatically
        }
    };


    useEffect(() => {
        if (userInfo) {
            if (personelPicName) {
                saveUserPersonnelImage(
                    userInfo.id,
                    personelPicBinery
                );
            }
            if (nationalCardPicName) {
                saveUsernationalImage(
                    userInfo.id,
                    nationalCardPicBinery
                );
            }
            if (certificationPicName) {
                saveUserBirthCertificationImage(
                    userInfo.id,
                    certificationPicBinery
                );
            }
            cardNumbersUserSetWitoutID.forEach(
                (item) => (item.userCode = userInfo.id)
            );
        }
    }, [userInfo])

    return (
        <>
            <div>
                <Formik
                    enableReinitialize
                    initialValues={{
                        name: user.firstName,
                        lastName: user.lastName,
                        nationalCode: user.nationalCode,
                        phone: user.mobileNumber,
                        code: "",
                        address: user.address,
                        fixedPhone: user.phoneNumber,
                        insta: user.instagramId,
                        telegram: user.telegramId,
                        email: user.email,
                        rol: "",
                        fixedPhonEemergency: user.emergencyNumber,
                        country: "",
                        city: "",
                        province: "",
                        userName: userSideBarAccess.userName,
                        password: ""
                    }}
                    validate={(values) => {
                        const errors = {};
                        if (values.name.length < 2) {
                            errors.name = "این فیلد اجباری میباشد";
                        } else if (values.name.length > 50) {
                            errors.name = "مقدار وارد شده نامعتبر میباشد";
                        } else if (values.lastName.length < 3) {
                            errors.lastName = "این فیلد اجباری میباشد";
                        } else if (values.name.length > 80) {
                            errors.lastName = "مقدار وارد شده نامعتبر میباشد";
                        } else if (values.nationalCode.length < 10) {
                            errors.nationalCode = "کدملی وارد شده نامعتبر میباشد";
                        } else if (!validNationalCode.test(values.nationalCode)) {
                            errors.nationalCode = "کدملی وارد شده نامعتبر میباشد";
                        }
                        //  else if (!validPhoneNumber.test(values.phone)) {
                        //   errors.phone = "شماره همراه وارد شده نامعتبر میباشد";
                        // }
                        // else if (!validCode.test(values.code)) {
                        //   errors.code = "کد تایید وارد شده نامعتبر میباشد";
                        // }
                        //  else if (!validFixedPhone.test(values.fixedPhone)) {
                        //   errors.fixedPhone = " شماره تلفن وارد شده نامعتبر میباشد";
                        // } 
                        else if (values.address.length < 10) {
                            errors.address = "مقدار وارد شده نامعتبر میباشد";
                        }
                        // else if (!validPhoneNumber.test(values.fixedPhoneEmergency)) {
                        //   errors.fixedPhoneEmergency =
                        //     "شماره همراه وارد شده نامعتبر میباشد";
                        // } 

                        // else if (!values.userName) {
                        //     errors.userName = "نام کاربری را وارد کنید";
                        // }
                        // else if (!values.password) {
                        //     errors.password = "رمز عبور را وارد کنید";
                        // }
                        // if (userInit?.userTypeCode !== 5) {
                        //   if (!values.country) {
                        //     errors.country = "کشور را انتخاب کنید";
                        //   } else if (!values.province) {
                        //     errors.province = "استان را انتخاب کنید";
                        //   } else if (!values.city) {
                        //     errors.city = "شهر را انتخاب کنید";
                        //   }
                        // }
                        return errors;
                    }}
                    onSubmit={async (values, event, errors) => {
                        if (!errors) {


                            await editAddUser(
                /* id */ params.id,
                /* lastUserId,*/ 0,
                /* firstName,*/  values.name,
                /* lastName,*/ values.lastName,
                /* businessExpertise,*/ null,
                /* businessAccountName,*/ null,
                /* adsMainCategoryCode,*/ 0,
                /* nationalCode,*/  values.nationalCode,
                /* email,*/ values.email,
                /* gender,*/ gender,
                /* mobileNumber,*/ values.phone,
                /* phoneNumber,*/ values.fixedPhone,
                /* emergencyNumber,*/ values.fixedPhonEemergency,
                /* birthDate,*/ /* convertNumbers2English(state.gregorian), */convertNumbers2English(isDateChanged ? state.gregorian : user?.registerDate || ""),
                /* country,*/ userInit?.userTypeCode == 5 ? userInit?.country : selectedCountry,
                /* state,*/ userInit?.userTypeCode == 5 ? userInit?.state : selectedProvince,
                /* city,*/userInit?.userTypeCode == 5 ? userInit?.city : selectedCity,
                /* longitudes,*/ 0,
                /* latitudes,*/ 0,
                /* address,*/  values.address,
                /* isBusinessUser,*/ false,
                /* description,*/ null,
                /* perssonelPicUrl,*/ null,
                /* businessLicensePicUrl,*/ null,
                /* shPicUrl,*/ null,
                /* otherDocumnetUrl,*/ null,
                /* nationalCardPicUrl,*/ null,
                /* positionCode,*/ 0,
                /* businessLicenseNumber,*/ null,
                /* instagramId,*/ null,
                /* telegramId,*/ null,
                /* userTypeCode,*/ isCityManager ? 5 : 3,
                /* userRegisterStatusCode,*/ 1,
                /* isUpdated,*/ false,
                /* isShowPhoneNumber,*/ false,
                /* isChatEnable*/ false
                            )
                            await addLogin(0,
                                Number(localStorage.getItem("userId")),
                                values.userName,
                                values.password,

                /*  canAccessCityState, */selectedAccess.cityAndProvinceManagement,
                /* canAccessUsers, */selectedAccess.users,
                /* canAccessCreateUser, */selectedAccess.createNewUser,
                /* canAccessUsersList, */selectedAccess.usersList,
                /* canAccessCreateAds, */selectedAccess.createFile,
                /* canAccessAdsList, */selectedAccess.filesList,
                /* canAccessIncompleteAdsList, */selectedAccess.inCompleteFiles,
                /* canAccessWaitingAds, */selectedAccess.awaitingApprovalFiles,
                /* waitingAdsState, */selectedProvince3,
                /* waitingAdsCity, */selectedCity3,
                /* incompleteAdsState, */selectedProvince2,
                /* incompleteAdsCity, */selectedCity2,
                /* canAccessMesageCenter, */selectedAccess.callCenter,
                /* canAccessMessages, */selectedAccess.messages,
                /* canAccessMonitoring, */selectedAccess.monitoring,
                /* canAccessTariffManagement, */selectedAccess.TariffManagement,
                /* canAccessDiscountsAndScores, */selectedAccess.DiscountsAndPrivileges,
                /* canAccessPrices, */selectedAccess.price,
                /* canAccessPrize, */selectedAccess.prize,
                /* canAccessContentManagement, */selectedAccess.ContentManagement,
                /* canAccessSlides, */selectedAccess.slides,
                /* canAcceessRules, */selectedAccess.rules,
                /* canAccessAlerts, */selectedAccess.automaticMessage,
                /* canAccessAbout, */selectedAccess.about,
                /* canAccessRealEstateAgents, */selectedAccess.RealEstateConsultants,
                /* canAccessRealEstateAgencies, */selectedAccess.RealEstateAgency,
                /* canAccessConstructors */selectedAccess.contractors,


                /* canAccessSupport */selectedAccess.support,
                /* canAccessReports */selectedAccess.reporteds,
                /* canAccessAutomaticMessages */selectedAccess.automaticMessage,
                /* canAccessBulkMessages */ selectedAccess.canAccessBulkMessages,
                /* canAccessMessagesOptions */ selectedAccess.messagesOption,
                                selectedAccess.canAccessBlog,
                                selectedAccess.canAccessAds,
                                selectedAccess.canAccessAdsValidity,

                            )
                            if (cardNumbersUserSetWitoutID.length) {
                                addCardNumbers(cardNumbersUserSetWitoutID);
                            }
                            // openNotification();
                            navigate("/usersList");
                        } else formNotCompleted();
                    }}
                >
                    {({
                        values,
                        errors,
                        touched,
                        handleChange,
                        handleBlur,
                        handleSubmit,
                        isSubmitting,
                    }) => (
                        <Form
                            onSubmit={handleSubmit}
                            className={`flex flex-col gap-4 mt-4 fade-in-b`}
                        >
                            <div className="grid grid-cols-4 gap-4  border-b py-2 xl:grid-cols-2 2xl:grid-cols-3">
                                {user?.userTypeCode >= 3 && (
                                    <div className="flex flex-col ">
                                        <label htmlFor="userName">نام کاربری *</label>
                                        <Field
                                            maxLength={50}
                                            type="text"
                                            name="userName"
                                            pattern="[\u0600-\u06FF\s]+"
                                            className="border-none outline-none bg-gray-100 p-1 rounded-xl"
                                        />
                                        <ErrorMessage name="userName">
                                            {(msg) => (
                                                <div className="text-[11px] text-red-600 pr-2">{msg}</div>
                                            )}
                                        </ErrorMessage>
                                    </div>
                                )}

                                <div className="flex flex-col ">
                                    <label htmlFor="password">رمز عبور *</label>
                                    <Field
                                        maxLength={50}
                                        type="text"
                                        name="password"
                                        pattern="[\u0600-\u06FF\s]+"
                                        className="border-none outline-none bg-gray-100 p-1 rounded-xl"
                                    />
                                    <ErrorMessage name="password">
                                        {(msg) => (
                                            <div className="text-[11px] text-red-600 pr-2">{msg}</div>
                                        )}
                                    </ErrorMessage>
                                </div>
                                <div className="flex flex-col ">
                                    <label htmlFor="name">نام *</label>
                                    <Field
                                        maxLength={50}
                                        type="text"
                                        name="name"
                                        pattern="[\u0600-\u06FF\s]+"
                                        className="border-none outline-none bg-gray-100 p-1 rounded-xl"
                                    />
                                    <ErrorMessage name="name">
                                        {(msg) => (
                                            <div className="text-[11px] text-red-600 pr-2">{msg}</div>
                                        )}
                                    </ErrorMessage>
                                </div>
                                <div className="flex flex-col ">
                                    <label htmlFor="lastName">نام خانوادگی *</label>
                                    <Field
                                        maxLength={80}
                                        type="text"
                                        name="lastName"
                                        className="border-none outline-none bg-gray-100 p-1 rounded-xl"
                                    />
                                    <ErrorMessage name="lastName">
                                        {(msg) => (
                                            <div className="text-[11px] text-red-600 pr-2">{msg}</div>
                                        )}
                                    </ErrorMessage>
                                </div>
                                <div className="flex flex-col ">
                                    <label htmlFor="nationalCode">کدملی *</label>
                                    <Field
                                        maxLength={10}
                                        pattern="\d{10}"
                                        type="text"
                                        name="nationalCode"
                                        className="border-none outline-none bg-gray-100 p-1 rounded-xl"
                                    />
                                    <ErrorMessage name="nationalCode">
                                        {(msg) => (
                                            <div className="text-[11px] text-red-600 pr-2">{msg}</div>
                                        )}
                                    </ErrorMessage>
                                </div>
                                <div className="flex flex-col ">
                                    <label htmlFor="gender">جنسیت *</label>
                                    <div className="flex items-center justify-between gap-4">
                                        {genderList.map((item) => (
                                            <button
                                                onClick={() => setGender(item.id)}
                                                name="sex"
                                                type="button"
                                                className={` bg-gray-100 p-1 rounded-xl flex-1 ${gender === item.id ? "border border-red-500" : ""
                                                    }`}
                                            >
                                                {item.title}
                                            </button>
                                        ))}
                                    </div>
                                </div>
                            </div>

                            <div className="grid grid-cols-2 gap-4 border-b py-2  xl:grid-cols-2 lg:grid-cols-3 2xl:grid-cols-3">
                                <div className="flex flex-col border-none outline-none  p-1 rounded-xl items-">
                                    <label htmlFor="phone">شماره همراه *</label>
                                    <div className="bg-gray-100 p-1 rounded-xl flex gap-0 items-center justify-between">
                                        <Field
                                            maxLength={11}
                                            pattern="(\+98|0)?9\d{9}"
                                            type="text"
                                            name="phone"
                                            className="border-none outline-none  bg-transparent w-[200px]"
                                        />
                                        {/* <button
                      type="button"
                      disabled={activeInterval}
                      onClick={countDownHandler}
                      className={` text-[10px] ${activeInterval ? `text-gray-600 ` : `text-green-600`
                        } `}
                    >
                      ارسال کد تایید
                    </button>
                    <div>
                      {activeInterval &&
                        `${minutes}:${seconds < 10 ? `0${seconds}` : seconds}`}
                    </div> */}
                                    </div>
                                    <ErrorMessage name="phone">
                                        {(msg) => (
                                            <div className="text-[11px] text-red-600 pr-2">{msg}</div>
                                        )}
                                    </ErrorMessage>
                                </div>
                                {/* <div className="flex flex-col ">
                                    <label htmlFor="code">کد تایید پیامکی *</label>
                                    <div className="bg-gray-100 p-1 rounded-xl flex items-center justify-between">
                                        <Field
                                            maxLength={4}
                                            type="text"
                                            name="code"
                                            className="border-none outline-none bg-transparent "
                                        />
                                        <img src="./icons/tik.svg" alt="ok" className="w-[18px]" />
                                    </div>
                                    <ErrorMessage name="code">
                                        {(msg) => (
                                            <div className="text-[11px] text-red-600 pr-2">{msg}</div>
                                        )}
                                    </ErrorMessage>
                                </div> */}
                                <div className="flex flex-col ">
                                    <label htmlFor="fixedPhone">شماره ثابت *</label>
                                    <Field
                                        maxLength={11}
                                        type="text"
                                        name="fixedPhone"
                                        className="border-none outline-none bg-gray-100 p-1 rounded-xl"
                                    />
                                    <ErrorMessage name="fixedPhone">
                                        {(msg) => (
                                            <div className="text-[11px] text-red-600 pr-2">{msg}</div>
                                        )}
                                    </ErrorMessage>
                                </div>
                                <div className="flex flex-col ">
                                    <label htmlFor="fixedPhonEemergency">
                                        شماره تماس اضطراری *
                                    </label>
                                    <Field
                                        maxLength={11}
                                        pattern="(\+98|0)?9\d{9}"
                                        type="text"
                                        name="fixedPhoneEmergency"
                                        className="border-none outline-none bg-gray-100 p-1 rounded-xl"
                                    />
                                    <ErrorMessage name="fixedPhoneEmergency">
                                        {(msg) => (
                                            <div className="text-[11px] text-red-600 pr-2">{msg}</div>
                                        )}
                                    </ErrorMessage>
                                </div>
                                <div className="flex items-center justify-between gap-2 pb-2 my-4 flex-col ">
                                    <div className="flex custom-date-picker gap-2 flex-col w-full">
                                        <label
                                            htmlFor="fixedPhonEemergency"
                                            className="flex items-center"
                                        >
                                            تاریخ تولد *
                                        </label>
                                        <div className="flex items-center  w-full bg-gray-100 rounded-xl flex-1 p-1">
                                            <img
                                                className="cursor-pointer "
                                                src="/icons/calendar.svg"
                                                alt="تقویم"
                                                onClick={handleShowDate}
                                            />
                                            <DatePicker
                                                ref={datePickerRef}
                                                className="green "
                                                arrow={false}
                                                value={state.date}
                                                onChange={convert}
                                                calendar={persian}
                                                locale={persian_fa}
                                                calendarPosition="bottom-right"
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="flex items-center justify-center">
                                    {userInit?.userTypeCode == 4 ?
                                        <Checkbox
                                            checked={isCityManager}
                                            value={isCityManager}
                                            onChange={() => setIsCityManager(!isCityManager)}
                                        > مدیر شهر</Checkbox> : <></>

                                    }

                                </div>
                            </div>

                            {userInit?.userTypeCode !== 5 ?
                                <div className="grid grid-cols-4 gap-4 border-b py-2 place-items-stretch items-center  xl:grid-cols-2 2xl:grid-cols-3">
                                    <Collapse items={CountriesCollapse} accordion activeKey={activeKeys} onChange={onCollapseChange} />
                                    {selectedCountry ? <Collapse items={provincesCollapse} accordion activeKey={activeKeys} onChange={onCollapseChange} /> : <></>}
                                    {selectedProvince ? <Collapse items={citiesCollapse} accordion activeKey={activeKeys} onChange={onCollapseChange} /> : (<></>)}
                                    {/* <div className="flex flex-col  ">
                    <label htmlFor="country">کشور *</label>
                    <Select
                      onChange={async (e) => {
                        console.log(e);
                        values.country = 1;
                      }}
                      defaultOpen={false}
                      showSearch
                      placeholder=""
                      optionFilterProp="children"
                      filterOption={(input, option) =>
                        (option?.label ?? "").includes(input)
                      }
                      filterSort={(optionA, optionB) =>
                        (optionA?.label ?? "")
                          .toLowerCase()
                          .localeCompare((optionB?.label ?? "").toLowerCase())
                      }
                    >
                      <Select.Option>
                        <span>ایران</span>
                      </Select.Option>
                    </Select>
                    <ErrorMessage name="country">
                      {(msg) => (
                        <div className="text-[11px] text-red-600 pr-2">{msg}</div>
                      )}
                    </ErrorMessage>
                  </div> */}


                                    {/* <div className={`flex flex-col`}>
                    <label htmlFor="province">استان *</label>
                    <Select
                      defaultOpen={false}
                      showSearch
                      placeholder=""
                      onChange={(e) => {
                        values.province = 2;
                      }}
                      optionFilterProp="children"
                      filterOption={(input, option) =>
                        (option?.label ?? "").includes(input)
                      }
                      filterSort={(optionA, optionB) =>
                        (optionA?.label ?? "")
                          .toLowerCase()
                          .localeCompare((optionB?.label ?? "").toLowerCase())
                      }
                    >
                      <Select.Option>
                        <span>تهران</span>
                      </Select.Option>
                    </Select>
                    <ErrorMessage name="province">
                      {(msg) => (
                        <div className="text-[11px] text-red-600 pr-2">{msg}</div>
                      )}
                    </ErrorMessage>
                  </div> */}


                                    {/* <div
                    className={`flex flex-col`}>
                    <label htmlFor="city">شهر *</label>
                    <Select
                      defaultOpen={false}
                      onChange={(e) => {
                        values.city = 3;
                      }}
                      showSearch
                      placeholder=""
                      optionFilterProp="children"
                      filterOption={(input, option) =>
                        (option?.label ?? "").includes(input)
                      }
                      filterSort={(optionA, optionB) =>
                        (optionA?.label ?? "")
                          .toLowerCase()
                          .localeCompare((optionB?.label ?? "").toLowerCase())
                      }>
                      <Select.Option>
                        <span>تهران</span>
                      </Select.Option>
                    </Select>
                    <ErrorMessage name="city">
                      {(msg) => (
                        <div className="text-[11px] text-red-600 pr-2">{msg}</div>
                      )}
                    </ErrorMessage>
                  </div> */}

                                </div> : <></>}



                            <div className="grid grid-cols-1 gap-4 border-b py-2 ">
                                <div className="flex flex-col border-none outline-none  p-1 rounded-xl items-start w-full">
                                    <label htmlFor="address">ادرس *</label>
                                    <Field
                                        maxLength={150}
                                        type="text"
                                        name="address"
                                        className="border-none outline-none  bg-gray-100 rounded-xl w-full p-1 w-full"
                                    />
                                    <ErrorMessage name="address">
                                        {(msg) => (
                                            <div className="text-[11px] text-red-600 pr-2">{msg}</div>
                                        )}
                                    </ErrorMessage>
                                </div>
                            </div>
                            <div className="grid grid-cols-2 gap-4 border-b py-4 ">
                                <div
                                    className={`relative mb-16 ${personelPicName
                                        ? "pointer-events-none opacity-50"
                                        : "pointer-events-auto opecity-100"
                                        }`}
                                >
                                    <label className="file-input__label" htmlFor="pic-personli">
                                        <input
                                            onChange={(e) => seveProfilePhotoHandler(e)}
                                            type="file"
                                            name="picPersonli"
                                            id=""
                                            className="file-input__input "
                                        />

                                        <span>
                                            عکس پرسنلی
                                            <ErrorMessage name="picPersonli">
                                                {(msg) => (
                                                    <div className="text-[11px] text-red-600 pr-2">
                                                        {msg}
                                                    </div>
                                                )}
                                            </ErrorMessage>
                                            {personelPicName && (
                                                <img
                                                    src={personelPicName}
                                                    className="w-28 h-16  absolute left-14 -top-2 "
                                                />
                                            )}
                                        </span>
                                        <img
                                            className="absolute"
                                            src="/icons/add-square.svg"
                                            alt="انتخاب عکس"
                                        />
                                    </label>
                                </div>

                                <div
                                    className={`relative  ${nationalCardPicName
                                        ? "pointer-events-none opacity-50"
                                        : "pointer-events-auto opecity-100"
                                        }`}
                                >
                                    <div>
                                        <label
                                            className="file-input__label"
                                            htmlFor="pic-national-card"
                                        >
                                            <input
                                                onChange={(e) => seveNationalCardPhotoHandler(e)}
                                                type="file"
                                                name="picNationalCard"
                                                id="file-input"
                                                className="file-input__input"
                                            />
                                            <span>
                                                عکس کارت ملی
                                                <ErrorMessage name="picNationalCard">
                                                    {(msg) => (
                                                        <div className="text-[11px] text-red-600 pr-2">
                                                            {msg}
                                                        </div>
                                                    )}
                                                </ErrorMessage>
                                            </span>
                                            <img
                                                className="absolute"
                                                src="/icons/add-square.svg"
                                                alt="انتخاب عکس"
                                            />
                                        </label>
                                    </div>
                                    <div>
                                        {nationalCardPicName && (
                                            <img
                                                src={nationalCardPicName}
                                                className="w-28 h-16  absolute left-14 -top-2 "
                                            />
                                        )}
                                    </div>
                                </div>
                                <div
                                    className={`relative ${certificationPicName
                                        ? "pointer-events-none opacity-50"
                                        : "pointer-events-auto opecity-100"
                                        }`}
                                >
                                    <label
                                        className="file-input__label "
                                        htmlFor="pic-shenasname"
                                    >
                                        <input
                                            onChange={(e) =>
                                                saveUserBirthCertificationImageHandler(e)
                                            }
                                            type="file"
                                            name="picShenasname"
                                            id="file-input"
                                            className="file-input__input "
                                        />
                                        <span>
                                            {" "}
                                            شناسنامه
                                            <ErrorMessage name="picShenasname">
                                                {(msg) => (
                                                    <div className="text-[11px] text-red-600 pr-2">
                                                        {msg}
                                                    </div>
                                                )}
                                            </ErrorMessage>
                                            {certificationPicName && (
                                                <img
                                                    src={certificationPicName}
                                                    className="w-28 h-16  absolute left-14 -top-2 "
                                                />
                                            )}
                                        </span>
                                        <img
                                            className="absolute"
                                            src="/icons/add-square.svg"
                                            alt="انتخاب عکس"
                                        />
                                    </label>
                                </div>
                                <div className="relative">
                                    <div
                                        className={`relative  ${documents
                                            ? "pointer-events-none opacity-50"
                                            : "pointer-events-auto opecity-100"
                                            }`}
                                    >
                                        <label className="file-input__label" htmlFor="pic-personli">
                                            <input
                                                onChange={(e) => saveDocumentHandler(e)}
                                                type="file"
                                                name="picPersonli"
                                                id=""
                                                className="file-input__input "
                                            />

                                            <span>
                                                سایر مدارک
                                                {documents && (
                                                    <img
                                                        src={documents}
                                                        className="w-28 h-16  absolute left-14 -top-2  "
                                                    />
                                                )}
                                            </span>
                                            <img
                                                className="absolute"
                                                src="/icons/add-square.svg"
                                                alt="انتخاب عکس"
                                            />
                                            <div className="flex items-center ">
                                                <input
                                                    type="text"
                                                    name="name"
                                                    className="border-none outline-none bg-gray-100 p-1 rounded-xl mr-10"
                                                    placeholder="نام"
                                                />
                                            </div>
                                        </label>
                                    </div>

                                    {/* <label className="file-input__label" htmlFor="pic-outher">
                    <input
                      type="file"
                      name="pic-outher"
                      id="file-input"
                      className="file-input__input"
                    />
                      <img
                        className="absolute left-0"
                        src="/icons/add-square.svg"
                        alt="انتخاب عکس"
                      />
                    <span> سایر مدارک</span>
                    <div className="flex items-center justify-center gap-2">
                      <input
                     
                        type="text"
                        name="name"
                        className="border-none outline-none bg-gray-100 p-1 rounded-xl"
                        placeholder="نام"
                      />
                    </div>
                  </label> */}
                                </div>
                            </div>
                            <div className="grid grid-cols-4 gap-4  border-b py-2">
                                <div className="flex flex-col col-span-2 ">
                                    <label htmlFor="email">ایمیل </label>
                                    <Field
                                        pattern="[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}"
                                        type="email"
                                        name="email"
                                        className="border-none outline-none bg-gray-100 p-1 rounded-xl"
                                        required
                                    />
                                    <ErrorMessage name="email">
                                        {(msg) => (
                                            <div className="text-[11px] text-red-600 pr-2">{msg}</div>
                                        )}
                                    </ErrorMessage>
                                </div>
                                <div className="flex flex-col ">
                                    <label htmlFor="insta">آیدی اینستاگرام</label>
                                    <div className="direction">
                                        <Field
                                            pattern="^@[a-zA-Z0-9._]+$"
                                            type="text"
                                            name="insta"
                                            className="border-none outline-none bg-gray-100 p-1 rounded-xl "
                                        />
                                    </div>
                                </div>
                                <div className="flex flex-col ">
                                    <label htmlFor="telegram">آیدی تلگرام</label>
                                    <div className="direction">
                                        <Field
                                            type="text"
                                            name="telegram"
                                            className="border-none outline-none bg-gray-100 p-1 rounded-xl "
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="grid grid-cols-2 gap-4  border-b py-2">
                                <div className="flex flex-col ">
                                    <label htmlFor="cardNumber">شماره کارت </label>
                                    <div
                                        className={`bg-gray-100 p-1 rounded-xl flex items-center justify-between`}
                                    >
                                        <input
                                            maxLength={19}
                                            // minLength={19}
                                            onChange={(e) => changeCardNumberInputValueHandler(e)}
                                            value={cardNumberInputValue}
                                            type="text"
                                            name="cardNumber"
                                            className={`border-none outline-none bg-transparent w-full `}
                                        />
                                        <img
                                            onClick={() => addCardNumberHandler()}
                                            src="/icons/pluse.svg"
                                            alt="حذف آیتم"
                                            className={`w-[20px] cursor-pointer `}
                                        />
                                    </div>
                                    <ErrorMessage name="cardNumber">
                                        {(msg) => (
                                            <div className="text-[11px] text-red-600 pr-2">{msg}</div>
                                        )}
                                    </ErrorMessage>
                                    <div className="flex flex-col items-center justify-center gap-1 mt-1">
                                        {cardNumbersUserSet.length ? (
                                            cardNumbersUserSet.map((item) => (
                                                <div
                                                    key={item.cardNumber}
                                                    className="px-2 py-1 rounded border flex items-center justify-between w-[80%] text-gray-600"
                                                >
                                                    {item.cardNumber}
                                                    <div className="flex items-center gap-1">
                                                        <img
                                                            src="/icons/min.svg"
                                                            alt="حذف ایتم"
                                                            className="cursor-pointer border p-1 rounded-full w-[25px] h-[27px]"
                                                            onClick={() => showRemoveModal(item)}
                                                        />
                                                        <img
                                                            onClick={() => showEditModal(item)}
                                                            src="/icons/edit.svg"
                                                            alt="ویرایش ایتم"
                                                            className="cursor-pointer border p-1 rounded-full w-[27px] h-[27px]"
                                                        />
                                                    </div>
                                                </div>
                                            ))
                                        ) : (
                                            <p className="text-sm text-gray-500">
                                                شماره کارتی ثبت نشده است
                                            </p>
                                        )}
                                    </div>
                                </div>
                                <div className="flex flex-col ">
                                    <label htmlFor="nightNumber">شماره شبا </label>
                                    <div
                                        className={`bg-gray-100 p-1 rounded-xl flex items-center justify-between`}
                                    >
                                        {" "}
                                        <img
                                            src="/icons/pluse.svg"
                                            alt="حذف آیتم"
                                            className={`w-[20px]  cursor-pointer mr-2`}
                                        />
                                        <div className="flex items-center justify-between bg-gray-100 w-full ">
                                            <input
                                                maxLength={24}
                                                value={shebaNumber}
                                                onChange={(e) => shebaNumberHandler(e)}
                                                type="text"
                                                name="nightNumber"
                                                className={`border-none outline-none bg-transparent w-full text-left ml-4`}
                                            />
                                            <span className="text-gray-600 border-r-2 ml-4">IR</span>
                                        </div>
                                    </div>
                                    <ErrorMessage name="nightNumber">
                                        {(msg) => (
                                            <div className="text-[11px] text-red-600 pr-2">{msg}</div>
                                        )}
                                    </ErrorMessage>
                                    <div className="flex flex-col items-center justify-center gap-1 mt-1">
                                        {/* {
                                            cardNumber.length ? cardNumber.map(item => (
                                                <div className='flex items-center justify-between bg-gray-200 w-[50%] py-1 px-2 rounded-xl'>
                                                    <span>1234567895821552</span>
                                                    <img src="/icons/min.svg" alt="حذف آیتم" />
                                                </div>
                                            )) : ""
                                        } */}
                                    </div>
                                </div>
                            </div>
                            {/* <div className='grid grid-cols-4 gap-4 py-2'>
                                <div className='flex flex-col  '>
                                    <label htmlFor="province">سمت*</label>
                                    <Select
                                        defaultOpen={false}
                                        showSearch
                                        placeholder=""
                                        optionFilterProp="children"
                                        filterOption={(input, option) => (option?.label ?? '').includes(input)}
                                        filterSort={(optionA, optionB) =>
                                            (optionA?.label ?? '').toLowerCase().localeCompare((optionB?.label ?? '').toLowerCase())
                                        }>
                                        <Select.Option value="amlak"><span>سمت اول</span></Select.Option>
                                        <Select.Option value="ahan"><span>سمت دوم</span></Select.Option>
                                    </Select>
                                </div>
                            </div>
                            <div className='flex flex-col mt-4 gap-2'>
                                <label>تعیین دسترسی</label>
                                <div className='grid grid-cols-3'>
                                    <Tree
                                        checkable
                                        onExpand={onExpand}
                                        expandedKeys={expandedKeys}
                                        onCheck={onCheck}
                                        checkedKeys={checkedKeys}
                                        onSelect={onSelect}
                                        selectedKeys={selectedKeys}
                                        treeData={treeDataOne}
                                    />
                                    <Tree
                                        checkable
                                        onExpand={onExpand}
                                        expandedKeys={expandedKeys}
                                        onCheck={onCheck}
                                        checkedKeys={checkedKeys}
                                        onSelect={onSelect}
                                        selectedKeys={selectedKeys}
                                        treeData={treeDataTwo}
                                    />
                                    <Tree
                                        checkable
                                        onExpand={onExpand}
                                        expandedKeys={expandedKeys}
                                        onCheck={onCheck}
                                        checkedKeys={checkedKeys}
                                        onSelect={onSelect}
                                        selectedKeys={selectedKeys}
                                        treeData={treeDataThree}
                                    />
                                </div>
                            </div> */}





                            {(user?.userTypeCode === 4 || user?.userTypeCode === 5)
                                ? (<div className="grid grid-cols-4 min-h-72">
                                    <div className="flex flex-col h-full justify-between items-start text-right relative">
                                        {/* Vertical Line */}
                                        <div className="absolute right-2 top-0 bottom-0 border-l-2 border-green-600"></div>

                                        {/* First Item */}
                                        <div className="relative flex items-center space-x-2 cursor-pointer" onClick={() => toggleSelection("cityAndProvinceManagement")}>
                                            <div className={`w-5 h-5 flex items-center justify-center rounded-full border-2 border-green-600 transition-all ml-2 ${selectedAccess.cityAndProvinceManagement ? "bg-green-600 text-white" : "bg-white text-green-600"}`}>
                                                {selectedAccess.cityAndProvinceManagement && <CheckCircleOutlined className="text-white text-xs" />}
                                            </div>
                                            <span className="font-semibold ">مدیریت شهر و استان</span>
                                        </div>

                                        {/* Second Section - Users */}
                                        <div className="relative flex items-center space-x-2 mt-4 " onClick={() => toggleSelection("users")}>

                                            <div className={`w-5 h-5 flex items-center justify-center rounded-full border-2 border-green-600 transition-all ml-2 ${selectedAccess.users ? "bg-green-600 text-white" : "bg-white text-green-600"}`}>
                                                {selectedAccess.users && <CheckCircleOutlined className="text-white text-xs" />}
                                            </div>
                                            <span className="font-semibold">کاربران</span>
                                        </div>


                                        {selectedAccess?.users ? (<div className="mr-6 space-y-2 text-gray-700 mt-3">
                                            <div className="flex items-center space-x-2" onClick={() => toggleSelection("createNewUser")}>
                                                {/* <div className="w-4 h-4 border-2 border-green-600 rounded-full"></div> */}
                                                <div
                                                    className={`w-5 h-5 flex items-center justify-center rounded-full border-2 border-green-600 transition-all ml-2 ${selectedAccess.createNewUser ? "bg-green-600 text-white" : "bg-white text-green-600"
                                                        }`}
                                                >
                                                    {selectedAccess.createNewUser && <CheckCircleOutlined className="text-white text-xs" />}
                                                </div>
                                                <span>ایجاد کاربر جدید</span>
                                            </div>

                                            <div className="flex items-center space-x-2" onClick={() => toggleSelection("usersList")} >
                                                {/* <div className="w-4 h-4 border-2 border-green-600 rounded-full"></div> */}
                                                <div
                                                    className={`w-5 h-5 flex items-center justify-center rounded-full border-2 border-green-600 transition-all ml-2 ${selectedAccess.usersList ? "bg-green-600 text-white" : "bg-white text-green-600"
                                                        }`}
                                                >
                                                    {selectedAccess.usersList && <CheckCircleOutlined className="text-white text-xs" />}
                                                </div>
                                                <span>لیست کاربران</span>
                                            </div>


                                            {/* <div className="flex items-center space-x-2" onClick={() => toggleSelection("settings")}>


                                                <div
                                                    className={`w-5 h-5 flex items-center justify-center rounded-full border-2 border-green-600 transition-all ml-2 ${selectedAccess.settings ? "bg-green-600 text-white" : "bg-white text-green-600"
                                                        }`}
                                                >
                                                    {selectedAccess.settings && <CheckCircleOutlined className="text-white text-xs" />}
                                                </div>
                                                <span>تنظیمات</span>
                                            </div> */}
                                        </div>
                                        ) : (<></>)}



                                        <div className="relative flex items-center space-x-2 mt-4 " onClick={() => toggleSelection("ContentManagement")}>

                                            <div className={`w-5 h-5 flex items-center justify-center rounded-full border-2 border-green-600 transition-all ml-2 ${selectedAccess.ContentManagement ? "bg-green-600 text-white" : "bg-white text-green-600"}`}>
                                                {selectedAccess.users && <CheckCircleOutlined className="text-white text-xs" />}
                                            </div>
                                            <span className="font-semibold">مدیریت محتوا</span>
                                        </div>


                                        {selectedAccess?.ContentManagement ? (<div className="mr-6 space-y-2 text-gray-700 mt-3">
                                            <div className="flex items-center space-x-2" onClick={() => toggleSelection("slides")}>
                                                {/* <div className="w-4 h-4 border-2 border-green-600 rounded-full"></div> */}
                                                <div
                                                    className={`w-5 h-5 flex items-center justify-center rounded-full border-2 border-green-600 transition-all ml-2 ${selectedAccess.slides ? "bg-green-600 text-white" : "bg-white text-green-600"
                                                        }`}
                                                >
                                                    {selectedAccess.slides && <CheckCircleOutlined className="text-white text-xs" />}
                                                </div>
                                                <span>  مدیریت اسلاید ها</span>
                                            </div>

                                            <div className="flex items-center space-x-2" onClick={() => toggleSelection("rules")} >
                                                {/* <div className="w-4 h-4 border-2 border-green-600 rounded-full"></div> */}
                                                <div
                                                    className={`w-5 h-5 flex items-center justify-center rounded-full border-2 border-green-600 transition-all ml-2 ${selectedAccess.rules ? "bg-green-600 text-white" : "bg-white text-green-600"
                                                        }`}
                                                >
                                                    {selectedAccess.rules && <CheckCircleOutlined className="text-white text-xs" />}
                                                </div>
                                                <span>قوانین و مقررات</span>
                                            </div>

                                            {/* <div className="flex items-center space-x-2" onClick={() => toggleSelection("messagesCadr")} >
                                            
                                                <div
                                                    className={`w-5 h-5 flex items-center justify-center rounded-full border-2 border-green-600 transition-all ml-2 ${selectedAccess.messagesCadr ? "bg-green-600 text-white" : "bg-white text-green-600"
                                                        }`}
                                                >
                                                    {selectedAccess.messagesCadr && <CheckCircleOutlined className="text-white text-xs" />}
                                                </div>
                                                <span> مدیریت   کادرهای پیام</span>
                                            </div> */}


                                            <div className="flex items-center space-x-2" onClick={() => toggleSelection("about")}>
                                                {/* <div className="w-4 h-4 border-2 border-green-600 rounded-full"></div> */}

                                                <div
                                                    className={`w-5 h-5 flex items-center justify-center rounded-full border-2 border-green-600 transition-all ml-2 ${selectedAccess.about ? "bg-green-600 text-white" : "bg-white text-green-600"
                                                        }`}
                                                >
                                                    {selectedAccess.about && <CheckCircleOutlined className="text-white text-xs" />}
                                                </div>
                                                <span>درباره ما</span>
                                            </div>


                                        </div>) : (<></>)}






                                        {/* Last Item */}
                                        <div className="relative flex items-center space-x-2 mt-4 cursor-pointer" onClick={() => toggleSelection("transactions")}>
                                            <div className={`w-5 h-5 flex items-center justify-center rounded-full border-2 border-green-600 transition-all ml-2 ${selectedAccess.transactions ? "bg-green-600 text-white" : "bg-white text-green-600"}`}>
                                                {selectedAccess.transactions && <CheckCircleOutlined className="text-white text-xs" />}
                                            </div>
                                            <span className="font-semibold">تراکنش ها</span>
                                        </div>
                                        <div className="relative flex items-center space-x-2 mt-4 cursor-pointer" onClick={() => toggleSelection("canAccessBlog")}>
                                            <div className={`w-5 h-5 flex items-center justify-center rounded-full border-2 border-green-600 transition-all ml-2 ${selectedAccess.canAccessBlog ? "bg-green-600 text-white" : "bg-white text-green-600"}`}>
                                                {selectedAccess.canAccessBlog && <CheckCircleOutlined className="text-white text-xs" />}
                                            </div>
                                            <span className="font-semibold">بلاگ ها</span>
                                        </div>
                                    </div>






                                    <div className="flex flex-col items-start text-right relative">
                                        {/* Vertical Line */}
                                        <div className="absolute right-2 top-0 bottom-0 border-l-2 border-green-600"></div>

                                        {/* First Item */}
                                        <div className="relative flex items-center space-x-2 mt-4 " onClick={() => toggleSelection("canAccessAds")}>

                                            <div className={`w-5 h-5 flex items-center justify-center rounded-full border-2 border-green-600 transition-all ml-2 ${selectedAccess.canAccessAds ? "bg-green-600 text-white" : "bg-white text-green-600"}`}>
                                                {selectedAccess.canAccessAds && <CheckCircleOutlined className="text-white text-xs" />}
                                            </div>
                                            <span className="font-semibold">آگهی ها</span>
                                        </div>
                                        {selectedAccess.canAccessAds ?
                                            (<div className="mr-6">
                                                <div className="relative flex items-center space-x-2 cursor-pointer " onClick={() => toggleSelection("createFile")}>
                                                    <div className={`w-5 h-5 flex items-center justify-center rounded-full border-2 border-green-600 transition-all ml-2 ${selectedAccess.createFile ? "bg-green-600 text-white" : "bg-white text-green-600"}`}>
                                                        {selectedAccess.createFile && <CheckCircleOutlined className="text-white text-xs" />}
                                                    </div>
                                                    <span > ایجاد آگهی </span>
                                                </div>


                                                <div className="relative flex items-center space-x-2 " onClick={() => toggleSelection("filesList")}>
                                                    <div className={`w-5 h-5 flex items-center justify-center rounded-full border-2 border-green-600 transition-all ml-2 ${selectedAccess.filesList ? "bg-green-600 text-white" : "bg-white text-green-600"}`}>
                                                        {selectedAccess.filesList && <CheckCircleOutlined className="text-white text-xs" />}
                                                    </div>
                                                    <span >لیست آگهی ها</span>
                                                </div>
                                                <div className="relative flex items-center space-x-2 " onClick={() => toggleSelection("canAccessAdsValidity")}>
                                                    <div className={`w-5 h-5 flex items-center justify-center rounded-full border-2 border-green-600 transition-all ml-2 ${selectedAccess.canAccessAdsValidity ? "bg-green-600 text-white" : "bg-white text-green-600"}`}>
                                                        {selectedAccess.canAccessAdsValidity && <CheckCircleOutlined className="text-white text-xs" />}
                                                    </div>
                                                    <span >اعتبار آگهی ها</span>
                                                </div>

                                            </div>) : (<></>)}
                                        <div className="h-full flex flex-col justify-between">



                                            <div className="relative flex items-center space-x-2 cursor-pointer" onClick={() => toggleSelection("inCompleteFiles")}>
                                                <div className={`w-5 h-5 flex items-center justify-center rounded-full border-2 border-green-600 transition-all ml-2 ${selectedAccess.inCompleteFiles ? "bg-green-600 text-white" : "bg-white text-green-600"}`}>
                                                    {selectedAccess.inCompleteFiles && <CheckCircleOutlined className="text-white text-xs" />}
                                                </div>
                                                <span > فایل های ناقصی  </span>
                                            </div>
                                            <div>
                                                <Collapse items={provincesCollapse2} accordion activeKey={activeKeys} onChange={onCollapseChange} className="collapse-green mb-3" />
                                                {selectedProvince2 ? <Collapse items={citiesCollapse2} accordion activeKey={activeKeys} onChange={onCollapseChange} className="collapse-green" /> : (<></>)}
                                            </div>
                                            <div className="relative flex items-center space-x-2 cursor-pointer" onClick={() => toggleSelection("awaitingApprovalFiles")}>
                                                <div className={`w-5 h-5 flex items-center justify-center rounded-full border-2 border-green-600 transition-all ml-2 ${selectedAccess.awaitingApprovalFiles ? "bg-green-600 text-white" : "bg-white text-green-600"}`}>
                                                    {selectedAccess.awaitingApprovalFiles && <CheckCircleOutlined className="text-white text-xs" />}
                                                </div>
                                                <span >   فایل های در انتظار تائید  </span>
                                            </div>
                                            <div>
                                                <Collapse items={provincesCollapse3} accordion activeKey={activeKeys} onChange={onCollapseChange} className="collapse-green mb-3" />
                                                {selectedProvince2 ? <Collapse items={citiesCollapse3} accordion activeKey={activeKeys} onChange={onCollapseChange} className="collapse-green" /> : (<></>)}
                                            </div>
                                            {/* Sub-menu */}

                                        </div>

                                    </div>



                                    {/* <div className="grid grid-cols-3"> */}
                                    <div className="flex flex-col items-start text-right relative">
                                        <div className="absolute right-2 top-0 bottom-0 border-l-2 border-green-600"></div>

                                        <div className="flex flex-col justify-between h-full">
                                            <div className="relative flex items-center space-x-2 cursor-pointer" onClick={() => toggleSelection("callCenter")}>
                                                <div className={`w-5 h-5 flex items-center justify-center rounded-full border-2 border-green-600 transition-all ml-2 ${selectedAccess.callCenter ? "bg-green-600 text-white" : "bg-white text-green-600"}`}>
                                                    {selectedAccess.callCenter && <CheckCircleOutlined className="text-white text-xs" />}
                                                </div>
                                                <span >  مرکز تماس </span>
                                            </div>


                                            <div className="flex flex-col items-start text-right relative min-h-60">
                                                {/* {selectedAccess?.callCenter && <div className="absolute right-2 top-0 bottom-0 border-l-2 border-green-600"></div>} */}

                                                <div className="flex flex-col justify-between h-full">

                                                    {/* {selectedAccess?.callCenter ? (<div className="relative flex items-center space-x-2 cursor-pointer" onClick={() => toggleSelection("messages")}>
                          <div className={`w-5 h-5 flex items-center justify-center rounded-full border-2 border-green-600 transition-all ml-2 ${selectedAccess.messages ? "bg-green-600 text-white" : "bg-white text-green-600"}`}>
                            {selectedAccess.messages && <CheckCircleOutlined className="text-white text-xs" />}
                          </div>
                          <span > پیام ها</span>
                        </div>) : (<></>)} */}


                                                    {/* 
                        {selectedAccess?.messages && selectedAccess?.callCenter ? (<div className="flex flex-col items-start text-right relative min-h-50 mr-7">
                          <div className="absolute right-2 top-0 bottom-0 border-l-2 border-green-600"></div>
                          <div className="flex flex-col justify-between h-full">
                            <div className="relative flex items-center space-x-2 cursor-pointer" onClick={() => toggleSelection("support")}>
                              <div className={`w-5 h-5 flex items-center justify-center rounded-full border-2 border-green-600 transition-all ml-2 ${selectedAccess.support ? "bg-green-600 text-white" : "bg-white text-green-600"}`}>
                                {selectedAccess.support && <CheckCircleOutlined className="text-white text-xs" />}
                              </div>
                              <span > پشتیبانی</span>
                            </div>
                            <div className="relative flex items-center space-x-2 cursor-pointer" onClick={() => toggleSelection("requests")}>
                              <div className={`w-5 h-5 flex items-center justify-center rounded-full border-2 border-green-600 transition-all ml-2 ${selectedAccess.requests ? "bg-green-600 text-white" : "bg-white text-green-600"}`}>
                                {selectedAccess.requests && <CheckCircleOutlined className="text-white text-xs" />}
                              </div>
                              <span > درخواست‌ها</span>
                            </div>
                            <div className="relative flex items-center space-x-2 cursor-pointer" onClick={() => toggleSelection("messagesList")}>
                              <div className={`w-5 h-5 flex items-center justify-center rounded-full border-2 border-green-600 transition-all ml-2 ${selectedAccess.messagesList ? "bg-green-600 text-white" : "bg-white text-green-600"}`}>
                                {selectedAccess.messagesList && <CheckCircleOutlined className="text-white text-xs" />}
                              </div>
                              <span > لیست پیام‌ها</span>
                            </div>
                            <div className="relative flex items-center space-x-2 cursor-pointer" onClick={() => toggleSelection("reporteds")}>
                              <div className={`w-5 h-5 flex items-center justify-center rounded-full border-2 border-green-600 transition-all ml-2 ${selectedAccess.reporteds ? "bg-green-600 text-white" : "bg-white text-green-600"}`}>
                                {selectedAccess.reporteds && <CheckCircleOutlined className="text-white text-xs" />}
                              </div>
                              <span >  گزارش شده ها</span>
                            </div>
                            <div className="relative flex items-center space-x-2 cursor-pointer" onClick={() => toggleSelection("automaticMessage")}>
                              <div className={`w-5 h-5 flex items-center justify-center rounded-full border-2 border-green-600 transition-all ml-2 ${selectedAccess.automaticMessage ? "bg-green-600 text-white" : "bg-white text-green-600"}`}>
                                {selectedAccess.automaticMessage && <CheckCircleOutlined className="text-white text-xs" />}
                              </div>
                              <span >  پیام خودکار</span>
                            </div>
                            <div className="relative flex items-center space-x-2 cursor-pointer" onClick={() => toggleSelection("BulkMessages")}>
                              <div className={`w-5 h-5 flex items-center justify-center rounded-full border-2 border-green-600 transition-all ml-2 ${selectedAccess.BulkMessages ? "bg-green-600 text-white" : "bg-white text-green-600"}`}>
                                {selectedAccess.BulkMessages && <CheckCircleOutlined className="text-white text-xs" />}
                              </div>
                              <span >  ارسال پیام گروهی</span>
                            </div>




                            <div className="relative flex items-center space-x-2 cursor-pointer" onClick={() => toggleSelection("systemErrorReport")}>
                              <div className={`w-5 h-5 flex items-center justify-center rounded-full border-2 border-green-600 transition-all ml-2 ${selectedAccess.systemErrorReport ? "bg-green-600 text-white" : "bg-white text-green-600"}`}>
                                {selectedAccess.systemErrorReport && <CheckCircleOutlined className="text-white text-xs" />}
                              </div>
                              <span >    تنظیمات پیام ها</span>
                            </div>
                          </div>
                        </div>) : (<></>)} */}

                                                    {/* {selectedAccess?.callCenter ?
                          (<div className="relative flex items-center space-x-2 cursor-pointer" onClick={() => toggleSelection("calls")}>
                            <div className={`w-5 h-5 flex items-center justify-center rounded-full border-2 border-green-600 transition-all ml-2 ${selectedAccess.calls ? "bg-green-600 text-white" : "bg-white text-green-600"}`}>
                              {selectedAccess.calls && <CheckCircleOutlined className="text-white text-xs" />}
                            </div>
                            <span >   تماس ها </span>
                          </div>)
                          : (<></>)} */}
                                                    {selectedAccess.callCenter ? (<div className="mr-6 space-y-2 text-gray-700 mt-3">
                                                        <div className="flex items-center space-x-2" onClick={() => toggleSelection("support")}>
                                                            {/* <div className="w-4 h-4 border-2 border-green-600 rounded-full"></div> */}
                                                            <div
                                                                className={`w-5 h-5 flex items-center justify-center rounded-full border-2 border-green-600 transition-all ml-2 ${selectedAccess.support ? "bg-green-600 text-white" : "bg-white text-green-600"
                                                                    }`}
                                                            >
                                                                {selectedAccess.support && <CheckCircleOutlined className="text-white text-xs" />}
                                                            </div>
                                                            <span>  پشتیبانی</span>
                                                        </div>

                                                        {/* <div className="flex items-center space-x-2" onClick={() => toggleSelection("messagesList")} >
                                                           
                                                            <div
                                                                className={`w-5 h-5 flex items-center justify-center rounded-full border-2 border-green-600 transition-all ml-2 ${selectedAccess.messagesList ? "bg-green-600 text-white" : "bg-white text-green-600"
                                                                    }`}
                                                            >
                                                                {selectedAccess.messagesList && <CheckCircleOutlined className="text-white text-xs" />}
                                                            </div>
                                                            <span> لیست پیام ها</span>
                                                        </div> */}
                                                        <div className="flex items-center space-x-2" onClick={() => toggleSelection("reporteds")} >
                                                            {/* <div className="w-4 h-4 border-2 border-green-600 rounded-full"></div> */}
                                                            <div
                                                                className={`w-5 h-5 flex items-center justify-center rounded-full border-2 border-green-600 transition-all ml-2 ${selectedAccess.reporteds ? "bg-green-600 text-white" : "bg-white text-green-600"
                                                                    }`}
                                                            >
                                                                {selectedAccess.reporteds && <CheckCircleOutlined className="text-white text-xs" />}
                                                            </div>
                                                            <span>  گزارش شده ها</span>
                                                        </div>
                                                        <div className="flex items-center space-x-2" onClick={() => toggleSelection("automaticMessage")} >
                                                            {/* <div className="w-4 h-4 border-2 border-green-600 rounded-full"></div> */}
                                                            <div
                                                                className={`w-5 h-5 flex items-center justify-center rounded-full border-2 border-green-600 transition-all ml-2 ${selectedAccess.automaticMessage ? "bg-green-600 text-white" : "bg-white text-green-600"
                                                                    }`}
                                                            >
                                                                {selectedAccess.automaticMessage && <CheckCircleOutlined className="text-white text-xs" />}
                                                            </div>
                                                            <span>    پیام خودکار</span>
                                                        </div>
                                                        <div className="flex items-center space-x-2" onClick={() => toggleSelection("canAccessBulkMessages")} >
                                                            {/* <div className="w-4 h-4 border-2 border-green-600 rounded-full"></div> */}
                                                            <div
                                                                className={`w-5 h-5 flex items-center justify-center rounded-full border-2 border-green-600 transition-all ml-2 ${selectedAccess.canAccessBulkMessages ? "bg-green-600 text-white" : "bg-white text-green-600"
                                                                    }`}
                                                            >
                                                                {selectedAccess.canAccessBulkMessages && <CheckCircleOutlined className="text-white text-xs" />}
                                                            </div>
                                                            <span>     ارسال پیام گروهی</span>
                                                        </div>
                                                        <div className="flex items-center space-x-2" onClick={() => toggleSelection("messagesOption")} >
                                                            {/* <div className="w-4 h-4 border-2 border-green-600 rounded-full"></div> */}
                                                            <div
                                                                className={`w-5 h-5 flex items-center justify-center rounded-full border-2 border-green-600 transition-all ml-2 ${selectedAccess.messagesOption ? "bg-green-600 text-white" : "bg-white text-green-600"
                                                                    }`}
                                                            >
                                                                {selectedAccess.messagesOption && <CheckCircleOutlined className="text-white text-xs" />}
                                                            </div>
                                                            <span>       تنظیمات پیام ها</span>
                                                        </div>
                                                        {/* <div className="flex items-center space-x-2" onClick={() => toggleSelection("ContentManagement")} >

                      <div
                        className={`w-5 h-5 flex items-center justify-center rounded-full border-2 border-green-600 transition-all ml-2 ${selectedAccess.ContentManagement ? "bg-green-600 text-white" : "bg-white text-green-600"
                          }`}
                      >
                        {selectedAccess.ContentManagement && <CheckCircleOutlined className="text-white text-xs" />}
                      </div>
                      <span>مدیریت محتوا</span>
                    </div> */}





                                                    </div>) : (<></>)}
                                                </div>
                                            </div>

                                            <div className="relative flex items-center space-x-2 cursor-pointer" onClick={() => toggleSelection("monitoring")}>
                                                <div className={`w-5 h-5 flex items-center justify-center rounded-full border-2 border-green-600 transition-all ml-2 ${selectedAccess.monitoring ? "bg-green-600 text-white" : "bg-white text-green-600"}`}>
                                                    {selectedAccess.monitoring && <CheckCircleOutlined className="text-white text-xs" />}
                                                </div>
                                                <span >   مانیتورینگ </span>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="flex flex-col h-full justify-between items-start text-right relative">
                                        {/* Vertical Line */}
                                        <div className="absolute right-2 top-0 bottom-0 border-l-2 border-green-600"></div>

                                        {/* First Item */}
                                        <div className="relative flex items-center space-x-2 cursor-pointer" onClick={() => toggleSelection("TariffManagement")}>
                                            <div className={`w-5 h-5 flex items-center justify-center rounded-full border-2 border-green-600 transition-all ml-2 ${selectedAccess.TariffManagement ? "bg-green-600 text-white" : "bg-white text-green-600"}`}>
                                                {selectedAccess.TariffManagement && <CheckCircleOutlined className="text-white text-xs" />}
                                            </div>
                                            <span className="font-semibold ">  مدیریت تعرفه ها </span>
                                        </div>

                                        {selectedAccess.TariffManagement ? (<div className="mr-6 space-y-2 text-gray-700 mt-3">
                                            <div className="flex items-center space-x-2" onClick={() => toggleSelection("DiscountsAndPrivileges")}>
                                                {/* <div className="w-4 h-4 border-2 border-green-600 rounded-full"></div> */}
                                                <div
                                                    className={`w-5 h-5 flex items-center justify-center rounded-full border-2 border-green-600 transition-all ml-2 ${selectedAccess.DiscountsAndPrivileges ? "bg-green-600 text-white" : "bg-white text-green-600"
                                                        }`}
                                                >
                                                    {selectedAccess.DiscountsAndPrivileges && <CheckCircleOutlined className="text-white text-xs" />}
                                                </div>
                                                <span>  تخفیفات و امتیازات</span>
                                            </div>

                                            <div className="flex items-center space-x-2" onClick={() => toggleSelection("price")} >
                                                {/* <div className="w-4 h-4 border-2 border-green-600 rounded-full"></div> */}
                                                <div
                                                    className={`w-5 h-5 flex items-center justify-center rounded-full border-2 border-green-600 transition-all ml-2 ${selectedAccess.price ? "bg-green-600 text-white" : "bg-white text-green-600"
                                                        }`}
                                                >
                                                    {selectedAccess.price && <CheckCircleOutlined className="text-white text-xs" />}
                                                </div>
                                                <span> قیمت</span>
                                            </div>
                                            <div className="flex items-center space-x-2" onClick={() => toggleSelection("prize")} >
                                                {/* <div className="w-4 h-4 border-2 border-green-600 rounded-full"></div> */}
                                                <div
                                                    className={`w-5 h-5 flex items-center justify-center rounded-full border-2 border-green-600 transition-all ml-2 ${selectedAccess.prize ? "bg-green-600 text-white" : "bg-white text-green-600"
                                                        }`}
                                                >
                                                    {selectedAccess.prize && <CheckCircleOutlined className="text-white text-xs" />}
                                                </div>
                                                <span> جایزه ها</span>
                                            </div>
                                            {/* <div className="flex items-center space-x-2" onClick={() => toggleSelection("ContentManagement")} >

                      <div
                        className={`w-5 h-5 flex items-center justify-center rounded-full border-2 border-green-600 transition-all ml-2 ${selectedAccess.ContentManagement ? "bg-green-600 text-white" : "bg-white text-green-600"
                          }`}
                      >
                        {selectedAccess.ContentManagement && <CheckCircleOutlined className="text-white text-xs" />}
                      </div>
                      <span>مدیریت محتوا</span>
                    </div> */}





                                        </div>) : (<></>)}




                                        <div className="relative flex items-center space-x-2" onClick={() => toggleSelection("RealEstateConsultants")} >
                                            {/* <div className="w-4 h-4 border-2 border-green-600 rounded-full"></div> */}
                                            <div
                                                className={`w-5 h-5 flex items-center justify-center rounded-full border-2 border-green-600 transition-all ml-2 ${selectedAccess.RealEstateConsultants ? "bg-green-600 text-white" : "bg-white text-green-600"
                                                    }`}
                                            >
                                                {selectedAccess.RealEstateConsultants && <CheckCircleOutlined className="text-white text-xs" />}
                                            </div>
                                            <span className="font-semibold">مشاورین املاک </span>
                                        </div>
                                        <div className="relative flex items-center space-x-2" onClick={() => toggleSelection("RealEstateAgency")} >
                                            {/* <div className="w-4 h-4 border-2 border-green-600 rounded-full"></div> */}
                                            <div
                                                className={`w-5 h-5 flex items-center justify-center rounded-full border-2 border-green-600 transition-all ml-2 z-1  ${selectedAccess.RealEstateAgency ? "bg-green-600 text-white" : "bg-white text-green-600"
                                                    }`}
                                            >
                                                {selectedAccess.RealEstateAgency && <CheckCircleOutlined className="text-white text-xs" />}
                                            </div>
                                            <span className="font-semibold"> آژانس املاک </span>
                                        </div>


                                        {/* Sub-menu */}


                                        {/* Last Item */}
                                        <div className="relative flex items-center space-x-2 mt-4 cursor-pointer" onClick={() => toggleSelection("contractors")}>
                                            <div className={`w-5 h-5 flex items-center justify-center rounded-full border-2 border-green-600 transition-all ml-2 z-1 ${selectedAccess.contractors ? "bg-green-600 text-white" : "bg-white text-green-600"}`}>
                                                {selectedAccess.contractors && <CheckCircleOutlined className="text-white text-xs" />}
                                            </div>
                                            <span className="font-semibold"> سازندگان</span>
                                        </div>
                                    </div>

                                    {/* </div> */}


                                </div>) : (<></>)}


                            <div className="flex items-center justify-center my-8">
                                <button
                                    onClick={handleSubmit}
                                    type="submit"
                                    className="bg-green-900 text-white w-[20%] text-white py-1 rounded-xl"
                                >
                                    ویرایش همکار
                                </button>
                            </div>
                        </Form>
                    )}
                </Formik>
            </div>

            <Modal
                title=""
                open={isModalRemoveOpen}
                onCancel={handleRemoveCancel}
                footer={null}
            >
                <div className="p-8">
                    <div className="flex item-center justify-center flex-col mt-8 text-center">
                        <span className="flex items-center gap-1">
                            آیا از حذف
                            <span className="font-bold">
                                {selected ? selected.cardNumber : ""}
                            </span>
                            اطمینان دارید؟
                        </span>
                        {/* <textarea className='bg-gray-100 outline-none p-2 rounded-xl w-full mt-2' placeholder='علت حذف خود را شرح دهید'></textarea> */}
                    </div>
                    <div className="flex items-center justify-center my-8 gap-2">
                        <button
                            onClick={() => removeCardHandler()}
                            className="bg-red-900 text-white w-[40%] text-white py-1 rounded-xl"
                        >
                            حذف شماره کارت
                        </button>
                    </div>
                </div>
            </Modal>

            <Modal
                title=""
                open={isModalEditOpen}
                onCancel={() => setIsModalEditOpen(false)}
                footer={null}
            >
                <div className="p-4">
                    <Formik
                        initialValues={{
                            newNameEdit: newName,
                        }}
                        validate={(values) => {
                            const errors = {};
                            if (!newName) {
                                errors.newNameEdit =
                                    "برای ثبت ویرایش لطفا نام جدید را وارد کنید";
                            }
                            return errors;
                        }}
                        onSubmit={async (values, event) => {


                            const editedCardNumber = (cardNumbersUserSet.find(
                                (item) => item.id === editbleCardNumber.id
                            ).cardNumber = newName);
                            // await editCardNumbers(editbleCardNumber.id, newName, editbleCardNumber.userCode)
                            setIsModalEditOpen(false);
                            // getCardNumbers(JSON.parse(localStorage.getItem("userId")))
                            setNewName("");
                        }}
                    >
                        {({
                            values,
                            errors,
                            touched,
                            handleChange,
                            handleBlur,
                            handleSubmit,
                            isSubmitting,
                        }) => (
                            <Form
                                onSubmit={handleSubmit}
                                className={`flex flex-col gap-2 mt-4 fade-in-b `}
                            >
                                <span className=" flex items-center gap-1">
                                    ویرایش :
                                    <span className="font-bold">
                                        {selected ? selected.locName : ""}
                                    </span>
                                </span>
                                <div className="bg-gray-100 p-1 rounded-xl flex items-center justify-between">
                                    <Field
                                        maxLength={16}
                                        value={newName}
                                        onChange={(e) => setNewName(e.target.value)}
                                        name="newNameEdit"
                                        className="border-none outline-none bg-transparent "
                                    />
                                </div>
                                <ErrorMessage name="newNameEdit">
                                    {(msg) => (
                                        <div className="text-[11px] text-red-600 pr-2">{msg}</div>
                                    )}
                                </ErrorMessage>
                                <div className="flex items-center justify-center my-8 gap-2">
                                    <button
                                        type="submit"
                                        className="bg-green-900 text-white w-[20%] text-white py-1 rounded-xl"
                                    >
                                        ثبت ویرایش
                                    </button>
                                </div>
                            </Form>
                        )}
                    </Formik>
                </div>
            </Modal>
        </>
    );
}

export default UserEdit;
const openCardNotification = () => {
    notification.open({
        icon: (
            <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke-width="1.5"
                stroke="currentColor"
                class="w-6 h-6"
            >
                <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="M12 9v3.75m9-.75a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9 3.75h.008v.008H12v-.008Z"
                />
            </svg>
        ),
        message: "اخطار",
        description: "شماره کارت وارد شده معتبر نمیباشد",
    });
};
const formNotCompleted = () => {
    notification.open({
        icon: (
            <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke-width="1.5"
                stroke="currentColor"
                class="w-6 h-6"
            >
                <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="M12 9v3.75m9-.75a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9 3.75h.008v.008H12v-.008Z"
                />
            </svg>
        ),
        message: "اخطار",
        description: "لطفا تمامی اطلاعات لازم را به درستی وارد کنید",
    });
};